module.exports = __webpack_public_path__ + "static/img/indexmodbg.601f2fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/indexmodbg.png
// module id = jbxE
// module chunks = 1